import React, {useState, useEffect, useContext} from "react"
import FormInput from "../FormInput/FormInput";
import FormCheckbox from "../FormInput/FormCheckbox";
import { validate_email, validate_password } from "../../utils/validiiations"
import "./LoginForm.scss"
import {Link} from 'gatsby'
import { UserContext } from '../../utils/usermanagement'
import { navigate } from "gatsby"

const LoginForm = ({loginForm, engagement, location}) => {

	const [userState, userDispatch] = useContext(UserContext);
	const [isDisabled, setIsDisabled] = useState("")
	const [displyPassword, setDisplyPassword] = useState('hide');
	const [state, setState] = useState({
		email: "",
		password: "",
		errors: {},
		isValid: {
			email: false,
			password: false,
		}
	});

	const loginDispatcher = () => {
  		userDispatch({action: 'login', data: {
					email: state.email,
					password: state.password
				}
		});

		isFormValid();
	};

	useEffect(() => {
		if(userState.status === 'login_success') {
			navigate('/dashboard/');
		}

		if(userState.status === 'login_failure') {
			setIsDisabled('');
		}
	},[userState])

	useEffect(() => {
		var elementName = '';
    if(location != null) {
      if(location?.state)
       elementName = location?.state?.goToElement;
    }

		if(elementName != ''){
			var element = document.getElementById(elementName);
			if(element){
				element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
			}
		}
	})

	const isFormValid = () => {
		const newState = { ...state }

		return 	newState.isValid.email &&
				newState.isValid.password;
	}

	const validate = (e) => {
		e.preventDefault();

		const newState = { ...state }
		validateEmail(newState.email);
		validatePassword(newState.password);

		const isValidForm =  isFormValid();
		if(isValidForm){
			setIsDisabled('disabled');
		}

		return isValidForm;
	}

	const validateEmail = (v) => {
		const newState = {...state};
		const [valid, msg] = validate_email(v);
		if (!valid) {
			newState.errors.email = msg
			newState.isValid.email= false;
		} else {
			newState.email = msg;
			newState.errors.email = "";
			newState.isValid.email = true;
		}
		setState(newState);
	}

	const validatePassword = (v, hideError) => {
		const newState = {...state};
		const [valid, msg] = validate_password(v);

		if(valid){
			newState.password = msg;
			newState.errors.password = "";
			newState.isValid.password= true;
		} else if (!valid) {
			newState.isValid.password= false;
			if(!hideError) {
				newState.errors.password = msg;
				newState.isValid.password= false;
			}

		}
		setState(newState);
	}


	const handleKeyPress = (e) => {
		validatePassword(e.currentTarget.value, true);

		if(e.keyCode === 13){
			if(validate(e)) {
				loginDispatcher();
			}
		}
	}

	const togglePasswordDisplay = (e) => {
		if(displyPassword === 'show') {
			setDisplyPassword('hide');
		} else {
			setDisplyPassword('show');
		}
	}

	return(
		<section id="login" className="login-form text-center">
			<div className="container container-sm">
				<div className="form-wrapper form">
						{ userState.status === 'login_failure' &&  <div className="error-box"><p>{ userState.message }</p></div> }
							<div className="row">
								<div className="col-12 col-md-6">
									<FormInput type="email" name="email" label="Email" id="loginEmail" state={state} updateState={(e) => { validateEmail(e.currentTarget.value);} } />
								</div>
								<div className="col-12 col-md-6 text-start">
									<div className="password-wrapper">
										<FormInput type={displyPassword === "show" ? "text" : "password"} name="password" label="Password" id="loginPassword" state={state}
											updateState={(e) => { validatePassword(e.currentTarget.value); }}
											keyPress={(e) => { handleKeyPress(e)} }>
											<span className={`show-hide-password ${displyPassword}`} onClick={togglePasswordDisplay}></span>
										</FormInput>

									</div>
									<Link to={`/account/forgot-password/`} className="link link-primary forgot-password arrow small"
									    data-analytics={`{ "event" : "forgotPassword", "actionType" : "Link Click", "loginStatus": "logged-out", "clickText" : "Forgot password", "linkType" : "internal", "linkUrl" : "${process.env.GATSBY_APP_DOMAIN}/account/forgot-password/", "pageName" : "Parent-Homepage" , "moduleName" : "${engagement} - Engagement", "userType" : "anonymous" }`}>
											Forgot Password?
									</Link>
								</div>
								<div className="col-12 col-md-6 remember-me d-none">
									<FormCheckbox type="checkbox" label="Remember my email address" id="tnc" />
								</div>

							</div>
							<button type="submit" className={`btn btn-primary float-right ${isDisabled}`}
								data-analytics={`{ "event" : "logIn", "actionType" : "CTA Click - Log in", "loginStatus": "logged-out", "clickText" : "Log in", "linkType" : "internal", "linkUrl" : "${process.env.GATSBY_APP_DOMAIN}", "pageName" : "Parent register page" , "moduleName" : "${engagement} - Engagement", "userType" : "anonymous" }`}
								onClick={(e)=> {
									if(validate(e)) {
										loginDispatcher()
									}
								}}>
									Log In
							</button>

					</div>
					<div className="text-start">
						<Link to={`/register/`} className="link link-primary register-link arrow small"
							data-analytics={`{ "event" : "logIn", "actionType" : "CTA Click", "loginStatus": "logged-out", "clickText" : "Not a member yet? Register here", "linkType" : "internal", "linkUrl" : "${process.env.GATSBY_APP_DOMAIN}/register/", "pageName" : "Parent register page" , "moduleName" : "${engagement} - Engagement", "userType" : "anonymous" }`}>
							Not a member yet? Register here
						</Link>
					</div>
			</div>
		</section>
	)
}

export default LoginForm
